<div class="wrapper">
    <!-- Chọn ngôn ngữ -->
    <div class="mb-3">
        <app-select-language-config [isAdmin]="true"></app-select-language-config>
    </div>
    <!-- form add & edit -->
    <div class="main-menu">
        <!-- Sửa menu -->
        <div class="select-link-page">
            <!-- Nhóm (group) -->
            <div *ngIf="data.item.level == 0" class="content-left">
                <nz-radio-group style="display:grid;gap: 5px;margin-top: 15px;"
                    [(ngModel)]="data.item.group"
                    (ngModelChange)="onChangeAttr()">
                    <ng-container *ngFor="let item of listGroupLink">
                        <label nz-radio *ngIf="data.groups.includes(item.url)" [nzValue]="item.url">{{item.name}}</label>
                    </ng-container>
                </nz-radio-group>
            </div>
            <div class="content-right">
                <!-- Danh sách loại link -->
                <div class="fill-name-menu">
                    <nz-radio-group nzName="radiogroup"
                        [(ngModel)]="data.item.type"
                        (ngModelChange)="onChangeAttr()">
                        <label nz-radio *ngFor="let link of listLink" [nzValue]="link.url">{{link.name}}</label>
                    </nz-radio-group>
                </div>
                <!-- Tên menu -->
                <div class="fill-name-menu">
                    <p class="title-name">Tên menu:</p>
                    <input class="field-fill" nz-input placeholder="Nhập tên menu"
                        [(ngModel)]="data.item['name_' + functionService.selectedLanguageCode]"
                        (input)="onChangeAttr()" />
                </div>
                <!-- Nhóm: Đường dẫn (link) -->
                <div class="connect-page">
                    <!-- Chọn liên kết loại Không (none) -->
                    <div class="group-link">
                    </div>
                    <!-- Chọn liên kết loại Đến trang (link-page) -->
                    <div class="group-link" *ngIf="data.item.type == 'link-page'">
                        <!-- Trang liên kết -->
                        <div class="fill-name-menu">
                            <p class="title-name">Trang liên kết:</p>
                            <div class="elementor-select">
                                <nz-select nzAllowClear class="field-fill" style="width:100%"
                                    [nzPlaceHolder]="data.item.link_page ? data.item.link_page : 'Chọn trang liên kết'"
                                    [(ngModel)]="data.item.link_page"
                                    (ngModelChange)="onChangeAttr()">
                                    <nz-option *ngFor="let page of listLinkPage"
                                        [nzLabel]="page.name | translate"
                                        [nzValue]="page._id || ''"></nz-option>
                                </nz-select>
                            </div>
                        </div>
                    </div>
                    <!-- Chọn liên kết loại Liên kết (website) -->
                    <div class="group-link" *ngIf="data.item.type == 'website'">
                        <!-- Liên kết Website -->
                        <div class="fill-name-menu">
                            <p class="title-name">Liên kết Website: </p>
                            <div class="elementor-select">
                                <input nz-input class="field-fill" placeholder="Nhập liên kết"
                                    style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
                                    [(ngModel)]="data.item.link_website"
                                    (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>
                    <!-- Chọn liên kết loại URL (link-url) -->
                    <div class="group-link" *ngIf="data.item.type == 'link-url'">
                        <!-- Link sản phẩm -->
                        <div class="fill-name-menu">
                            <p class="title-name">Link sản phẩm: </p>
                            <div class="elementor-select">
                                <input nz-input class="field-fill" placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                                    style="border-top-left-radius: 0px;border-bottom-left-radius: 0px"
                                    [(ngModel)]="data.item.link_url"
                                    (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>

                    <div class="fill-name-menu" *ngIf="data.item.type != 'none'">
                        <p class="title-name">{{'hanh_dong_khi_nhan' | translate}}:</p>
                        <div class="elementor-select">
                            <nz-select nzAllowClear class="field-fill" style="width:100%"
                                [nzPlaceHolder]="'cuon_len_dau_trang' | translate"
                                [(ngModel)]="data.item.is_scroll"
                                (ngModelChange)="onChangeAttr()">
                                <nz-option [nzLabel]="'cuon_len_dau_trang' | translate" [nzValue]="true"></nz-option>
                                <nz-option [nzLabel]="'giu_nguyen_vi_tri' | translate" [nzValue]="false"></nz-option>
                            </nz-select>
                        </div>
                      </div>
                </div>
                <!-- Nhóm: Gọi danh mục (category) -->
                <div class="connect-category" *ngIf="data.item.group == 'category'">
                    <div class="group-link">
                        <!-- Các danh mục con sẽ dẫn tới trang -->
                        <div class="fill-name-menu">
                            <p class="title-name">Các danh mục con sẽ dẫn tới trang: </p>
                            <div class="elementor-select">
                                <nz-select nzAllowClear class="field-fill" nzPlaceHolder="Chọn trang danh mục"
                                    [(ngModel)]="data.item.id_page_category"
                                    (ngModelChange)="onChangeAttr()">
                                    <nz-option *ngFor="let page of listPageCategory"
                                        [nzLabel]="page.name"
                                        [nzValue]="page._id"></nz-option>
                                </nz-select>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Nhóm: Gọi hộp thoại (pop-up) -->
                <div class="connect-popup" *ngIf="data.item.group == 'pop-up'" style="display: flex; align-items: flex-end; gap: 20px; margin-top: 15px">
                    <!-- Hộp thoại -->
                    <div class="fill-name-menu">
                        <p class="title-name">Hộp thoại: </p>
                        <nz-select nzAllowClear class="field-fill" nzPlaceHolder="Chọn hộp thoại hiển thị"
                            [(ngModel)]="data.item.id_freeblock"
                            (ngModelChange)="onChangeAttr()">
                            <nz-option *ngFor="let block of listBlockPopup"
                                [nzValue]="block._id"
                                [nzLabel]="block.name"></nz-option>
                        </nz-select>
                    </div>
                    <button [disabled]="type == 'build'" nz-button nzType="primary" (click)="createNewBlock()">{{'tao_hop_thoai' | translate}}</button>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="button-add" style="display:flex;align-items: center;justify-content: flex-end;gap:5px;margin-top: 15px;">
    <button nz-button (click)="cancelFormEditMenu()">Hủy</button>
    <button nz-button nzType="primary" [disabled]="!isValid" (click)="saveFormEditMenu()">Lưu</button>
</div>